<template functional>
    <b-icon icon="box-arrow-up-right" class="mx-2" :style="{'opacity': props.opacity}"></b-icon>
</template>

<script>

export default {
    functional: true,
    name: 'ExternalLinkIcon',
    props: {
        opacity: {
            type: [Number, String],
            default: '0.7',
        }
    },
}
</script>

<style>

</style>